import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { reportErrorToBugsnag } from '@air/utils-error';

import { getAccountKey, useAccount } from '~/swr-hooks/account/useAccount';
import {
  isEmailVerifiedBroadcastMessage,
  subscribeToEmailVerifiedBroadcast,
} from '~/utils/auth/broadcastCurrentUserEmailVerified';

export const useIsCurrentUserEmailVerified = () => {
  const { data: account, isFetched } = useAccount();
  const queryClient = useQueryClient();
  const userEmail = account?.email;
  const userEmailIsVerified = account?.emailVerified;

  useEffect(() => {
    const unsubscribe = subscribeToEmailVerifiedBroadcast((event) => {
      if (
        !isEmailVerifiedBroadcastMessage(event.data) ||
        userEmail !== event.data.email ||
        userEmailIsVerified === true
      ) {
        return;
      }

      void queryClient.invalidateQueries({ queryKey: getAccountKey() }).catch((error: unknown) => {
        reportErrorToBugsnag({
          error,
          context: 'Failed to refresh account after email verified broadcast',
        });
      });
    });

    return unsubscribe;
  }, [queryClient, userEmail, userEmailIsVerified]);

  return {
    userEmailIsVerified,
    isFetched,
  };
};
